const mapStateToProps = (state)=>{
    // const geoObjs = state?.api?.geoObjs;
    // const getGeoObj = state?.service?.Api?.getGeoObj;
    // const selectedGeoObjArray = state?.ui?.selectedGeoObjArray;
    const {
        geozone:{
            geozoneVertexArr,
            geozoneArr,
        }={},


    } = state;
    return {
        geozoneVertexArr,
        geozoneArr,
    }
}

export default mapStateToProps